module.exports = __webpack_public_path__ + "media/images/icons/icon_triangle_arrow_left_white-dcee89d6ab0bc0f0029a2d517d53feba.svg";